import React, {
  CSSProperties, FC,
} from 'react';

const RowCenter = React.forwardRef<any, Props>((({
  children,
  style,
  onClick,
}, ref) => {
  return (
    <div
      ref={ref}
      style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', ...style }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
    </div>
  );
}));

export interface Props {
  children: any;
  style?: CSSProperties
  onClick?: () => void;
}

export default RowCenter;
